export const ACCOUNT_DELETED_EVENT = "app:account-deleted";

export const dispatchAccountDeleted = (): void => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(ACCOUNT_DELETED_EVENT));
};
